import { Store } from 'store';
import getEncPublicDesignId from 'store/product/selector/getEncPublicDesignId';
import getCategoryId from 'store/category/selector/getCategoryId';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import getProductId from 'store/product/selector/getProductId';
import isMobile from 'store/app/selector/isMobile';
import getProductQuantity from './getProductQuantity';

const getCommonProductRequestParams = (store: Store) => {
  const encPublicDesignId = getEncPublicDesignId(store);
  const categoryId = getCategoryId(store);
  const locale = getLocaleSelector(store);
  const productId = getProductId(store);
  const mobile = isMobile(store);
  const quantity = getProductQuantity(store);

  return {
    encPublicDesignId,
    categoryId,
    locale,
    productId,
    mobile,
    quantity,
  };
};

export default getCommonProductRequestParams;
